/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowMusicProductionWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowMusicProductionWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Create Some Tunes!",
    "Music Production Awaits!",
    "Unleash Your Inner Producer!",
  ],
  title: "Music Production Workshop",
  description: "Organize a creative music production workshop.",
  longDescription:
    "Gather your friends for a music production workshop! Choose a date, decide on music genres, and plan activities for the session!",
  emoji: "🎵",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Music Production Workshop",
          emoji: "🎵",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the music production workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on music genres to explore?",
            description:
              "What music genres should we focus on during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What genres should we choose?",
                emoji: "🎧",
                completeAction: {
                  question: "Decide on tools and software needed?",
                  description:
                    "What tools and software should we gather for production?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What tools should we bring?",
                      emoji: "💻",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Make Some Music!",
    outroDescription:
      "Your music production workshop plans are set! Enjoy creating!",
  },
};
